<!------------------------------------------------------------>
<!--------------------------- 注册页面 ------------------------>
<!------------------------------------------------------------>
<template>
    <div id="forgetForm" class="forget-form">
        <div>
            <h2 class="log-tit">忘记密码</h2>
            <p class="err f-err"></p>
            <p class="user">
                <el-input placeholder="用户名" v-model="username" required class="common-input" autofocus></el-input>
            </p>
            <div class="pw" style="margin-bottom: 20px;">
                <el-input placeholder="新密码" v-model="newPassword" show-password required
                    class="common-input"></el-input>
            </div>
            <div class="pw" style="margin-bottom: 20px;">
                <el-input placeholder="确认新密码" v-model="conpassword" show-password required
                    class="common-input"></el-input>
            </div>
            <div class="pw" style="margin-bottom: 20px; display: flex;">
                <el-input placeholder="验证码" v-model="code" required class="common-input"></el-input>
                <button @click="valideCode($event)" class="forget-yzm" :disabled="verificationDisabled">{{ verification }}</button>
            </div>
            <div class="forget-btns">
                <span @click="handleCancel" class="forget-cancel">取消</span>
                <el-button type="primary" @click="forgetConfirm()" class="btn-log" :loading="loading">确定</el-button>
            </div>
        </div>
    </div>

</template>


<script>
import { httpPostSecret } from "@/utils/utils"

export default {
    name: 'future-forget',
    data() {
        return {
            username: null,
            newPassword: null,
            conpassword: null,
            code: null,
            verification: "获取验证码",
            NONES: ['', undefined, null],
            loading: false,
            verificationDisabled: false,
        }
    },
    methods: {
        handleCancel() {
            this.username = null
            this.newPassword = null
            this.conpassword = null
            this.code = null

            this.$emit('cancel')
        },
        async valideCode() {
            const flag = this.valideFields()
            if (!flag) return

            this.verificationDisabled = true
            const url = "/api/user/sendSmsByForgot"
            let params = { username: this.username, newPassword: this.newPassword, code: this.code }
            const res = await httpPostSecret(url, params)

            if (res.rspCode === "000000") {
                let time = 60;
                let timer = null;
                this.$notify({
                    title: '温馨提示',
                    message: `请输入${res.data}收到的验证码`,
                    duration: 10000,
                    type: 'warning'
                });
                timer = setInterval(() => {
                    if (time > 0) {
                        time -= 1;
                        this.verification = time + 's'
                    } else {
                        this.verification = "获取验证码"
                        this.verificationDisabled = false
                        clearInterval(timer);
                    }
                }, 1000)
            } else {
                this.$message.error(res.rspMsg);
                this.verificationDisabled = false
                this.verification = '获取验证码'
            }
        },
        valideFields() {
            if (this.NONES.includes(this.username)) {
                this.$message.error('请输入用户名');
                return false;
            }
            if (this.NONES.includes(this.newPassword) || this.NONES.includes(this.conpassword)) {
                this.$message.error('请输入密码');
                return false;
            }
            if (this.newPassword !== this.conpassword) {
                this.$message.error('请确保密码两次输入一致');
                return false;
            }
            return true
        },
        async forgetConfirm() {
            const flag = this.valideFields()
            if (!flag) return

            this.loading = true
            const url = "/api/user/resetPassword"
            let params = { username: this.username, newPassword: this.newPassword, code: this.code }
            const res = await httpPostSecret(url, params)
            this.loading = false;
            if (res.rspCode === '000000') {
                this.handleCancel();
                this.$message.success("修改成功，请使用新密码登录");
            } else {
                this.$message.error(res.rspMsg);
            }
        },

    }
}
</script>
<style lang="less" scoped>
.forget-btns {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .forget-cancel {
        margin-right: 30px;
        white-space: nowrap;
        cursor: pointer;
        color: #1F5AD8;
    }
}

.forget-yzm {
    text-align: center;
    line-height: 34px;
    float: right;
    border: none;
    border-radius: 2px;
    margin-right: 6px;
    margin-top: 6px;
    height: 34px;
    width: 160px;
    font-size: 14px;
    background-color: rgba(80, 119, 216, 1);
    color: #fff;
    cursor: pointer;
    border-radius: 400px;
}

&:disabled {
    background-color: #76a0f8;
    cursor: default;
}

.forget-form {
    padding: 40px 50px 40px;
    box-sizing: border-box;
    max-width: 440px;
    min-width: 315px;
    background-color: #fff;
    border-radius: 8px;

    .log-tip {
        margin-bottom: 10px;
        color: #999999;
        font-size: 16px;
        line-height: 22px;
    }

    .user,
    .pw {
        border: 1px solid #dddddd;
        border-radius: 8px;
        padding-left: 50px;
        padding-right: 10px;
        box-sizing: border-box;
        width: 100%;
        height: 48px;
        transition: all 0.5s;
    }

    .user.b-blue,
    .pw.b-blue {
        border: 1px solid #5077d8;
    }

    .log-tit {
        margin-bottom: 18px;
        font-size: 24px;
        color: #333;

        &::after {
            content: "";
            width: 88px;
            height: 7px;
            background: #1f5ad8;
            display: block;
            margin-top: 10px;
        }
    }

    .user {
        margin-bottom: 20px;
        background: url(../../assets/images/future/icon-user.png) no-repeat 10px;
        background-size: 24px;
    }

    .user input,
    .pw input {
        border: none;
        height: 100%;
        outline: none;
        font-size: 16px;
        color: #333;
    }

    .user input {
        width: 100%;
    }

    .pw {
        position: relative;
        margin-bottom: 9vh;
        padding-right: 0px;
        background: url(../../assets/images/future/icon-lock.png) no-repeat 10px;
        background-size: 24px;

        input {
            width: 50%;
        }

        #verification {
            float: right;
            border: none;
            border-radius: 2px;
            margin-right: 6px;
            margin-top: 6px;
            height: 34px;
            width: 100px;
            font-size: 14px;
            background-color: rgba(80, 119, 216, 1);
            color: #fff;
            cursor: pointer;
            border-radius: 400px;

            &:disabled {
                background-color: #ccc;
                cursor: default;
            }
        }

        .pw-eye {
            float: right;
            padding-top: 15px;
            padding-right: 15px;
            width: 20px;
            cursor: pointer;
        }

        .pw-eye img {
            width: 100%;
        }
    }

    .err {
        display: none;
        padding: 4px;
        margin-bottom: 15px;
        border: 1px solid #fc0000;
        box-sizing: border-box;
        width: 100%;
        background-color: rgba(255, 0, 0, 0.2);
        font-size: 14px;
        font-weight: normal;
        color: #fc0000;
    }

    .btn-log {
        outline: none;
        width: 100%;
        height: 48px;
        background: #1f5ad8;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        border: 0;
    }
}

.common-input {
    height: 100%;

    ::v-deep .el-input__inner {
        border: 0;
        background-color: transparent;
        padding: 0;
        height: 100%;
        font-size: 16px;
    }
}
</style>